import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
  Paper,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as phoneNumberAction } from "../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps } from "../../redux/report/reportQuantity";
import { parseAutoFillDate } from "../../ultis/autoFillDate";

class ReportQuantity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          from: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
          to: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
          number: null,
        },
        page: 0,
        pageSize: 20,
      },
      currentStartDate: null,
      currentEndDate: null,
    };
  }

  async componentDidMount() {
    const { filters } = this.state;
    this.history = globalHistory();
    this.props.getListPhoneNumber();
    this.props.getListReportQuantity(
      filters.where.number,
      `${filters.where.from}`,
      `${filters.where.to}`,
      filters.where.type
    );
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      nextState.currentStartDate === null && nextState.currentEndDate === null
    );
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "number":
            case "type":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    if (filters.where.to && filters.where.from) {
      this.setState({ disable: false });
      this.props.getListReportQuantity(
        filters.where.number,
        `${filters.where.from}`,
        `${filters.where.to}`,
        filters.where.type
      );
    }
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = from
      ? datetimeHelper.toFormat(from, "YYYY-MM-DD")
      : null;
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = to ? datetimeHelper.toFormat(to, "YYYY-MM-DD") : null;
    this.setState({ to });
  };

  handleChange = (name) => {
    const { filters } = this.state;
    return (e) => {
      filters.where[name] = e.target.value;
      return this.setState({
        filters,
      });
    };
  };

  _export;
  export = () => {
    this._export.save();
  };

  render() {
    const { classes, listReportQuantity, listPhoneNumber } = this.props;
    const { filters } = this.state;
    const listReportQuantityResult =
      typeof listReportQuantity === "object"
        ? Object.keys(listReportQuantity).map((key) => listReportQuantity[key])
        : listReportQuantity;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from ? filters.where.from : null}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                          maxDate={
                            filters.where.to ? filters.where.to : new Date()
                          }
                          required={true}
                          ampm={false}
                          keyboard
                          invalidDateMessage="Định dạng Ngày không đúng"
                          maxDateMessage="Ngày lớn hơn ngày tối đa"
                          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                          onBlur={() => {
                            this.handleDateChangeStart(
                              this.state.currentStartDate
                                ? parseAutoFillDate(this.state.currentStartDate)
                                : null
                            );
                            this.setState({ currentStartDate: null });
                          }}
                          onKeyUp={(e) => {
                            this.setState({ currentStartDate: e.target.value });
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to ? filters.where.to : null}
                          maxDate={new Date()}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                          required={true}
                          ampm={false}
                          keyboard
                          invalidDateMessage="Định dạng Ngày không đúng"
                          maxDateMessage="Ngày lớn hơn ngày tối đa"
                          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                          onBlur={() => {
                            this.handleDateChangeEnd(
                              this.state.currentEndDate
                                ? parseAutoFillDate(this.state.currentEndDate)
                                : null
                            );
                            this.setState({ currentEndDate: null });
                          }}
                          onKeyUp={(e) => {
                            this.setState({ currentEndDate: e.target.value });
                          }}
                        />
                      </Grid>
                      <Grid item md={4}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Đầu số"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChange("number")}
                          value={filters.where.number}
                          name="number"
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem>
                            <em>Tất cả</em>
                          </MenuItem>
                          {listPhoneNumberResult ? (
                            listPhoneNumberResult.map((item, key) => {
                              return (
                                <MenuItem key={key} value={item.id}>
                                  {item.id}
                                </MenuItem>
                              );
                            })
                          ) : (
                            <React.Fragment />
                          )}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={4}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Phân loại"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.type}
                          name="type">
                          <MenuItem>Tất cả</MenuItem>
                          <MenuItem key="answered" value="inbound">
                            Gọi vào
                          </MenuItem>
                          <MenuItem key="busy" value="outbound">
                            Gọi ra
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid
                        item
                        md={4}
                        style={{ alignItem: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            type="submit">
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            onClick={this.export}
                            className={classes.fab}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
                <ExcelExport
                  data={
                    listReportQuantityResult.length > 3
                      ? JSON.parse(
                          JSON.stringify(listReportQuantityResult)
                        ).map((item, index) => {
                          if (index === 0) {
                            item.moreInfo = `Tổng sản lượng bưu tá gọi từ DingDong: ${
                              listReportQuantityResult.length
                                ? datetimeHelper.hhmmss(
                                    listReportQuantityResult[0]
                                      .totalCallDingDong
                                  )
                                : "00:00:00"
                            }`;
                          } else if (index === 1) {
                            item.moreInfo = `Tổng sản lượng bưu cục gọi ra: ${
                              listReportQuantityResult.length
                                ? datetimeHelper.hhmmss(
                                    listReportQuantityResult[0]
                                      .totalPostOfficeCallOut
                                  )
                                : "00:00:00"
                            }`;
                          } else if (index === 2) {
                            item.moreInfo = `Tổng sản lượng KH gọi lại bưu tá: ${
                              listReportQuantityResult.length
                                ? datetimeHelper.hhmmss(
                                    listReportQuantityResult[0]
                                      .totalCustomerCallBack
                                  )
                                : "00:00:00"
                            }`;
                          }
                          return item;
                        })
                      : [
                          ...JSON.parse(
                            JSON.stringify(listReportQuantityResult)
                          ),
                          {
                            moreInfo: `Tổng sản lượng bưu tá gọi từ DingDong: ${
                              listReportQuantityResult.length
                                ? datetimeHelper.hhmmss(
                                    listReportQuantityResult[0]
                                      .totalCallDingDong
                                  )
                                : "00:00:00"
                            }`,
                          },
                          {
                            moreInfo: `Tổng sản lượng bưu cục gọi ra: ${
                              listReportQuantityResult.length
                                ? datetimeHelper.hhmmss(
                                    listReportQuantityResult[0]
                                      .totalPostOfficeCallOut
                                  )
                                : "00:00:00"
                            }`,
                          },
                          {
                            moreInfo: `Tổng sản lượng KH gọi lại bưu tá: ${
                              listReportQuantityResult.length
                                ? datetimeHelper.hhmmss(
                                    listReportQuantityResult[0]
                                      .totalCustomerCallBack
                                  )
                                : "00:00:00"
                            }`,
                          },
                        ]
                  }
                  fileName="Báo cáo sản lượng.xlsx"
                  ref={(exporter) => (this._export = exporter)}>
                  <ExcelExportColumn field="moreInfo" title=" " width={350} />
                  <ExcelExportColumn field="date" title="Ngày" width={80} />
                  <ExcelExportColumn
                    field="number"
                    title="Đầu số"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="type"
                    title="Phân loại"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="answeredCalls"
                    title="Trả lời"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="missedCalls"
                    title="Nhỡ"
                    width={100}
                  />
                  <ExcelExportColumn field="ivrCalls" title="IVR" width={100} />
                  <ExcelExportColumn
                    field="rejectedCalls"
                    title="Từ chối"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="noAnsweredCalls"
                    title="Không trả lời"
                    width={80}
                  />
                  <ExcelExportColumn field="busyCalls" title="Bận" width={80} />
                  <ExcelExportColumn
                    field="failedCalls"
                    title="Lỗi"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="unknownCalls"
                    title="Chưa xác định"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="calls"
                    title="Tổng số cuộc"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="duration"
                    title="Tổng thời gian tính tiền"
                    width={80}
                  />
                </ExcelExport>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <Card style={{ marginTop: "15px" }}>
          <CardContent style={{ padding: 0 }}>
            <div style={{ marginLeft: "20px" }}>
              <p style={{ color: "#000000", marginTop: "15px" }}>
                Tổng sản lượng bưu tá gọi từ DingDong:{" "}
                <span>
                  {listReportQuantityResult.length
                    ? datetimeHelper.hhmmss(
                        listReportQuantityResult[0].totalCallDingDong
                      )
                    : "00:00:00"}
                </span>
              </p>
              <p style={{ color: "#000000", marginTop: "15px" }}>
                Tổng sản lượng bưu cục gọi ra:{" "}
                <span>
                  {listReportQuantityResult.length
                    ? datetimeHelper.hhmmss(
                        listReportQuantityResult[0].totalPostOfficeCallOut
                      )
                    : "00:00:00"}
                </span>
              </p>
              <p style={{ color: "#000000", marginTop: "15px" }}>
                Tổng sản lượng KH gọi lại bưu tá:{" "}
                <span>
                  {listReportQuantityResult.length
                    ? datetimeHelper.hhmmss(
                        listReportQuantityResult[0].totalCustomerCallBack
                      )
                    : "00:00:00"}
                </span>
              </p>
            </div>
          </CardContent>
        </Card>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    textAlign: "center",
                    padding: "4px 4px 4px 4px",
                  }}>
                  {" "}
                  Ngày
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    width: "180px",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Đầu số
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    textAlign: "center",
                  }}>
                  {" "}
                  Phân loại
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Trả lời
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Nhỡ
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  IVR
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Từ chối
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Không trả lời
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Bận
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Lỗi
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Chưa xác định
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Tổng số cuộc
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    padding: "4px 4px 4px 4px",
                    textAlign: "center",
                  }}>
                  {" "}
                  Tổng thời gian tính tiền
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listReportQuantityResult != 0
                ? listReportQuantityResult.map((row, key) => {
                    return (
                      <TableRow key={key} className={classes.row}>
                        {row.groups?.date.index === 0 ? (
                          <TableCell
                            component="th"
                            scope="row"
                            rowSpan={row.groups.date.count}
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              padding: "4px 4px 4px 4px",
                              textAlign: "center",
                            }}>
                            {row.date}
                          </TableCell>
                        ) : (
                          <React.Fragment />
                        )}

                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.number}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.type}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.answeredCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.missedCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.ivrCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.rejectedCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.noAnsweredCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            padding: "4px 4px 4px 4px",
                            textAlign: "center",
                          }}>
                          {row.busyCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            textAlign: "center",
                            padding: "4px 4px 4px 4px",
                          }}>
                          {row.failedCalls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            textAlign: "center",
                            padding: "4px 4px 4px 4px",
                          }}>
                          {row.unknownCalls ? row.unknownCalls : 0}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            textAlign: "center",
                            padding: "4px 4px 4px 4px",
                          }}>
                          {row.calls}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            textAlign: "center",
                            padding: "4px 4px 4px 4px",
                          }}>
                          {row.duration}
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
    "& p": {
      position: "absolute",
      top: "55px",
    },
  },
  form: {
    width: "100%",
  },
  rootDialog: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    overflowX: "auto",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#90a4ae",
    },
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f2f2f2",
    },
    "&:last-child": {
      backgroundColor: "#d9d9d9",
    },
  },
  head: {
    backgroundColor: "#f2f2f2",
    position: "sticky",
    top: 0,
  },
  button: {
    width: "40px",
    height: "40px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
  },
  fab: {
    marginRight: 10,
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
});

ReportQuantity.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listReportQuantity: state.reportQuantity.report,
  loading: state.reportQuantity.loading,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
});
const NumberConnect = connect(null, phoneNumberAction)(ReportQuantity);
ReportQuantity = connect(mapStateToProps, mapActionsToProps)(NumberConnect);
export default withStyles(styles)(ReportQuantity);
